import { Dashboard, Login } from "@mui/icons-material";
import CreateDbGroup from "./Body/CreateDbGroup/pageBody";
import EditDbGroup from "./Body/EditDbGroup/pageBody";

export const TEXT={
    Address:{en:"Address",ar:"العنوان"},    Chat:{en:"Chat",ar:"المحادثات"},    Class:{en:"Class",ar:"الصف"},
    ConfirmPassword:{en:"Confirm Password",ar:"تأكيد كلمة المرور"},
    CreateDB:{en:"Create database",ar:"انشاء قاعدة بيانات"},
    CreateDb:{en:"Create database",ar:"انشاء قاعدة بيانات"},
    CreateDbGroup:{en:"Create database group",ar:"انشاء مجموعة لقواعد البيانات"},
    DbBrowser:{en:"Database Browser",ar:"متصفح قواعد البيانات"},
    DbRecords:{en:"Database Records",ar:"سجلات قاعدة البيانات"},
    DontHaveAccount:{en:"Don't have an account?",ar:"ليس لديك حساب؟"},
    EditDbGroup:{en:"Edit database group",ar:"تعديل مجموعة قواعد البيانات"},
    EmailAddress:{en:"Email Address",ar:"البريد الالكتروني"},
    Export:{en:"Export database",ar:"توريد البيانات"},
    FirstName:{en:"First Name",ar:"الاسم الاول"},
    ForgetPassword:{en:"Forget Password",ar:"نسيت كلمة المرور"},
    Going:{en:"Going",ar:"اللي رايحين"},
    Home:{en:"Home",ar:"الرئيسية"},
    Import:{en:"Import database",ar:"استيراد البيانات"},
    LastName:{en:"Last Name",ar:"الاسم الاخير"},
    Login:{en:"Login",ar:"تسجيل الدخول"},
    Logout:{en:"Logout",ar:"تسجيل الخروج"},
    Missing:{en:"Missing",ar:"اللي مش موجودين"},
    Name:{en:"Name",ar:"الاسم"},
    Password:{en:"Password",ar:"كلمة المرور"},
    Profile:{en:"Profile",ar:"الملف الشخصي"},
    Registed:{en:"Registed",ar:"المسجلين"},
    Register:{en:"Register",ar:"تسجيل"},
    Registration:{en:"Registration",ar:"تسجيل"},
    RememberMe:{en:"Remember me",ar:"تذكر بياناتي"},
    Returning:{en:"Returning",ar:"اللي راجعين"},
    Session:{en:"Session",ar:"الجلسة"},
    Sessions:{en:"Sessions",ar:"الجلسات"},
    SignUp:{en:"Sign Up",ar:"انشاء حساب"},
    Task:{en:"Task",ar:"المهام"},
    Volanteering:{en:"Volanteering",ar:"التطوع"},
    DbManagement:{en:"Database Management",ar:"إدارة قاعدة البيانات"},
    Dashboard:{en:"Dashboard",ar:"لوحة المعلومات"},
    ChangeRequests:{en:"Change Requests",ar:"طلبات التغيير"},
    YjsTest:{en:"Yjs Test",ar:"تجربة Yjs"},
}
export default TEXT;  